import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import i18n, { storedLanguage } from "@/i18n";
import { toast } from "sonner";
import { applyLanguage } from "@/i18n/language";
import App from "@/App";
import { registerServiceWorker } from "@/pwa";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
const renderApp = () => root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

applyLanguage(storedLanguage).then(renderApp).catch(() => {
  // A stale/offline deployment must remain usable. The existing language
  // preference is retained so the missing language bundle can be retried.
  renderApp();
  toast.error(i18n.t("lang.loadError"));
});
registerServiceWorker();
